var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheatre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 88,
    viewBox: "0 0 68 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46074 8.26613C14.5573 -3.47715 57.0466 -2.0721 66.3596 8.46838C66.9288 9.11262 67.1771 9.95685 67.2249 10.8152C69.1533 45.4807 70.2441 88 34.9735 88C22.5313 88 -2.20454 77.4065 0.157896 11.2976C0.198433 10.1632 0.615646 9.02391 1.46074 8.26613ZM43.2611 27.967C41.4467 33.7264 44.8661 42.3805 53.7125 40.8589C56.9758 40.2976 57.5313 36.201 55.1862 33.8633L48.7627 27.4598C46.9823 25.6849 44.0165 25.5692 43.2611 27.967ZM17.611 40.8589C26.4574 42.3805 29.8769 33.7264 28.0624 27.967C27.307 25.5692 24.3412 25.6849 22.5608 27.4598L16.1373 33.8633C13.7923 36.201 14.3477 40.2976 17.611 40.8589ZM46.5555 66.2318C41.0856 65.532 33.7967 65.156 24.3674 66.4361C21.3519 66.8455 18.4629 64.5454 19.5744 61.7125C24.1163 50.1377 44.2518 47.4097 51.3466 60.6847C52.97 63.7221 49.9717 66.6689 46.5555 66.2318Z",
    fill: "#DB0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheatre);
export default __webpack_public_path__ + "static/media/theatre.f812ae2c392fd77e809288d67ac908d5.svg";
export { ForwardRef as ReactComponent };